
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import CharacterCounter from './CharacterCounter';

interface TextareaFieldProps {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  value: string;
  charCount: number;
  maxChars: number;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextareaField = ({
  id,
  name,
  label,
  placeholder,
  value,
  charCount,
  maxChars,
  onChange
}: TextareaFieldProps) => {
  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <Label htmlFor={id}>{label}</Label>
        <CharacterCounter current={charCount} max={maxChars} />
      </div>
      <Textarea
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="min-h-[100px] transition-all duration-200 focus-visible:ring-redflags-red/30"
      />
    </div>
  );
};

export default TextareaField;
